import { create } from 'zustand';

interface UIState {
  ui: {
    showDebugInfo: boolean;
    showConnectionStatus: boolean;
    statusMessage: string | null;
  };

  // UI Actions
  setShowDebugInfo: (show: boolean) => void;
  setShowConnectionStatus: (show: boolean) => void;
  setStatusMessage: (message: string | null) => void;
}

export const useWebSocketUIStore = create<UIState>((set) => ({
  ui: {
    showDebugInfo: false,
    showConnectionStatus: false,
    statusMessage: null,
  },

  // UI Actions
  setShowDebugInfo: (show: boolean) => {
    set((state) => ({
      ui: { ...state.ui, showDebugInfo: show },
    }));
  },

  setShowConnectionStatus: (show: boolean) => {
    set((state) => ({
      ui: { ...state.ui, showConnectionStatus: show },
    }));
  },

  setStatusMessage: (message: string | null) => {
    set((state) => ({
      ui: { ...state.ui, statusMessage: message },
    }));
  },
}));
